// removed by extract-text-webpack-plugin
module.exports = {"container":"_2SHehs18JeQ-MP1Vvl1o6P"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Loader/style.css
// module id = 1301
// module chunks = 0